// Tiny Web Audio helper. No sample files, just synthesized tones — keeps
// the bundle small and avoids the need for a public asset.

let ctx = null;
const STORAGE_KEY = 'mahjong_sound';
let enabled = loadPref();

function loadPref() {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'off';
  } catch {
    return true;
  }
}

function savePref() {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'on' : 'off');
  } catch {}
}

function getCtx() {
  if (!ctx) {
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    ctx = new C();
  }
  // Resume if the browser suspended it on initial page load.
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

function tone({ freq, duration, volume = 0.18, type = 'sine', startOffset = 0 }) {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  const t0 = c.currentTime + startOffset;
  osc.frequency.setValueAtTime(freq, t0);
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(volume, t0 + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.001, t0 + duration);
  osc.connect(gain);
  gain.connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.05);
}

export function dingYourTurn() {
  if (!enabled) return;
  tone({ freq: 880, duration: 0.12, volume: 0.2 });
  tone({ freq: 1320, duration: 0.18, volume: 0.18, startOffset: 0.1 });
}

export function clickTick() {
  if (!enabled) return;
  tone({ freq: 660, duration: 0.05, volume: 0.1 });
}

export function isEnabled() {
  return enabled;
}

export function setEnabled(v) {
  enabled = !!v;
  savePref();
}

export function toggleEnabled() {
  setEnabled(!enabled);
  return enabled;
}
